import React, { memo, useRef, useEffect, Fragment } from "react";
import { createPortal } from "react-dom";
import { useBoundStore } from "@maxis/client-logic/store/useBoundStore";
import useMessageBox from "@maxis/client-logic/hooks/useMessageBox";
import styles from "./MessageBox.module.css";

export default function MessageBox() {
  const root = document.getElementById("message-box");
  // store stack
  const stack = useBoundStore((s) => s.messageBox.stack);
  // get `popMessage` from the useMessageBox hook
  const { popMessage } = useMessageBox();

  return createPortal(
    <>
      {stack.map((msg) => (
        <MessageBoxItem
          key={msg.id}
          {...msg}
          onClose={(result) => {
            // when close modal, remove id of stack
            popMessage(msg.id);
            msg.responseHandler(result);
          }}
        />
      ))}
    </>,
    root
  );
}

const MessageBoxItem = memo(({ id, type, title, description, time, onClose }) => {
  const timerRef = useRef();

  // auto-close
  useEffect(() => {
    if (time) {
      timerRef.current = setTimeout(() => onClose(true), time);
    }
    return () => clearTimeout(timerRef.current);
  }, [time, onClose]);

  return (
    <>
      <div className={styles.dialogBackdrop} onClick={() => onClose(false)} />
      <dialog className={styles.dialog} open>
        <h2 className={styles[type] || styles.dialogTitle}>{title}</h2>
        {description && (
          <div className={styles.dialogDescription}>
            {typeof description === "string"
              ? description.split("\n").map((line, idx) => (
                  <Fragment key={idx}>
                    {line}
                    <br />
                  </Fragment>
                ))
              : description}
          </div>
        )}
        <div className={styles.dialogButtons}>
          <button
            type="button"
            className={`${styles.dialogButton} ${styles.dialogButtonConfirm}`}
            onClick={() => onClose(true)}
          >
            확인
          </button>
          {type !== "alert" && type !== "error" && (
            <button
              type="button"
              className={`${styles.dialogButton} ${styles.dialogButtonCancel}`}
              onClick={() => onClose(false)}
            >
              취소
            </button>
          )}
        </div>
      </dialog>
    </>
  );
});
MessageBoxItem.displayName = "MessageBoxItem";
